import { Component, OnInit, ElementRef, ViewChild, Output, EventEmitter } from "@angular/core";
import { UntypedFormBuilder, UntypedFormGroup, Validators } from "@angular/forms";
import { MatSnackBar } from '@angular/material/snack-bar';
import { Observable } from "rxjs";

import { ApplicantService } from "../../applicant.service";
import { CommonFieldsService } from "../../common-fields.service";
import { environment as ENV } from "../../../../environments/environment";

@Component({
  selector: "wl-profile",
  templateUrl: "./profile.component.html",
  styleUrls: ["./profile.component.scss"],
})
export class ProfileComponent implements OnInit {
  @ViewChild("fileInp") fileInp: ElementRef;

  profileForm: UntypedFormGroup;
  cities: Observable<any>;
  digitalKey: string;
  custId: string;
  profileImageSource = "../../assets/avatar5.png";
  isImageUploading: any;
  custTypes: Observable<any>;
  loanTypes: Observable<any>;

  placeholder: string;
  Pin: any;
  State: any;
  City: any;
  resState: any;
  resCity: any;
  showpinHint: Boolean;
  isPINfetch: Boolean;
  expLink: any;
  imageBufferData: string;
  imageBase64: any;
  imageBufferLink: string;

  // @Output() profileImg : EventEmitter<String> = new EventEmitter();

  constructor(
    private fb: UntypedFormBuilder,
    private snackbar: MatSnackBar,
    private applicant: ApplicantService,
    private common: CommonFieldsService
  ) {
    this.profileForm = this.fb.group({
      name: ["", Validators.required],
      // mobileNo: [null, Validators.compose([Validators.required, Validators.pattern(/^[0-9]{10}$/)])],
      // email: [null, Validators.compose([Validators.required, Validators.email])],
      // city: ['', Validators.required],
      // offAdd: ['', Validators.required],
      // resAdd: ['', Validators.required],
      mobileNo: [null],
      email: [null],
      offAdd: [""],
      resAdd: [""],
      // resUnitNo : [''],
      // offUnitNo:[''],
      pin: [""],
      city: [""],
      state: [""],
      // custType : [''],
      // loanType : ['']
    });
    // this.placeholder =  ENV.placeHolderSetting.placeholder;
  }

  //Buffer.from(data).toString('base64')
  ngOnInit() {
    this.cities = this.common.getCities();
    // this.custTypes = this.common.getEmpTypes();
    // this.loanTypes = this.common.getCustLoanTypes();
    console.log("cities " + JSON.stringify(this.cities));
    // this.applicantId = this.applicant.getApplicantID();

    this.applicant.getEverything().subscribe((allData) => {
      console.log("All Data ", allData);
      if (
        allData &&
        allData.docs &&
        allData.docs.id &&
        allData.docs.id &&
        allData.docs.id.aadhaar &&
        allData.docs.id.aadhaar.aadhaarxmlOutput &&
        allData.docs.id.aadhaar.aadhaarxmlOutput.data &&
        allData.docs.id.aadhaar.aadhaarxmlOutput.data.photo
      ) {
        var image = allData.docs.id.aadhaar.aadhaarxmlOutput.data.photo;
        this.profileImageSource = "data:image/png;base64," + image;
      } else if (
        allData &&
        allData.docs &&
        allData.docs.id &&
        allData.docs.id.dl &&
        allData.docs.id.dl.auth &&
        allData.docs.id.dl.auth.image
      ) {
        this.profileImageSource = ENV.imageUrl.slice(0, -1) + allData.docs.id.dl.auth.image;
      } else {
      }
    });

    this.applicant.getProfile().subscribe((profile) => {
      if (profile) {
        console.log(profile);
        this.profileForm.patchValue(profile);
        this.digitalKey =
          profile.digitalKey && profile.digitalKey.loankey ? profile.digitalKey.loankey : null;
        this.custId = profile.custId ? profile.custId : null;
        this.profileImageSource = profile.img ? profile.img : "../../assets/avatar5.png";
        //http://192.168.1.30:8081/v1/file/PROFILE/479d99a6-7c8a-441f-8728-b9fe1598dcfa
        this.imageBufferLink = `/file/PROFILE/${profile.img}`;
        console.log(this.imageBufferLink);
        if (profile && profile.img) {
          this.applicant.getImage(this.imageBufferLink).subscribe((resp) => {
            console.log(resp);
            if (resp && resp.result && resp.result.imageData && resp.result.imageData.data) {
              this.imageBase64 = resp.result.imageData.data;
              // this.imageBase64 = Buffer.from(this.imageBufferData).toString('base64')
              console.log(this.imageBase64);
              this.profileImageSource = `data:image/jpeg;base64,${this.imageBase64}`;
            }
          });
        }
      }
    });
    this.placeholder = "Customer ID";
  }

  pincode(args) {
    console.log("Pincode", args);
    if (args.target.value.length == 6) {
      this.isPINfetch = true;
      this.Pin = this.common.getPin(args.target.value).subscribe((resp) => {
        this.isPINfetch = false;
        if (resp[0].Status == "Success") {
          console.log("PIN " + JSON.stringify(resp));
          this.State = JSON.stringify(resp[0].PostOffice[0].State);
          this.resState = this.State.replace(/"/g, "");
          console.log("resState " + this.resState);
          this.City = JSON.stringify(resp[0].PostOffice[0].Block);
          this.resCity = this.City.replace(/"/g, "");
          console.log("resCity " + this.resCity);
          this.profileForm.patchValue({
            city: this.resCity,
            state: this.resState,
          });
        } else if (resp[0].Status == "Error") {
          this.snackbar.open("PIN Code does'nt Exist", "OK", { duration: 3000 });
        }
      });
    }
  }

  uploadProfilePic(event) {
    let fileType = event.srcElement.files[0].type;
    if (
      fileType === "application/pdf" ||
      fileType === "image/jpg" ||
      fileType === "image/png" ||
      fileType === "image/jpeg"
    ) {
      const fd = new FormData();
      let upload = event.target || event.srcElement;
      fd.append("file", upload.files[0]);
      this.isImageUploading = true;
      console.log(fd.getAll("file"));
      this.applicant.uploadProfilePic(fd).subscribe((res) => {
        this.isImageUploading = false;
        console.log("res " + res);
        this.ngOnInit();
      });
    } else {
      this.snackbar.open(
        "Invalid Document, Please upload any of the following file formats(.jpg, .jpeg, .png, .pdf) ",
        "OK",
        { duration: 6000 }
      );
    }
  }

  updateProfile(profile) {
    console.log("profile " + JSON.stringify(profile));
    let proPic = this.profileImageSource.split("/");
    profile.img = "/" + proPic[4] + "/" + proPic[5];
    this.applicant.updateProfile(profile).subscribe((status) => {

      // config.duration = 5000;
      // config.extraClasses = ['custom-dialog-container']
      this.snackbar.open("Successfully Updated", "OK", { duration: 3000 });
    });
  }

  virtualClick() {
    this.fileInp.nativeElement.click();
  }

  //   fetchDSA(mobile) {
  //   console.log("Vinod Alwa = > ", mobile);
  //   this.applicant.getDSAinfo(mobile).subscribe(dsaInfo => {
  //     this.dsaData = dsaInfo;
  //     console.log('DSA Info', this.dsaData);
  //   });
  // }
}
